import { Container } from '@acies/core';
import { IconTitleSection } from '@acies/ui';
import CreatePositionRenderer from './create-position-renderer';
import PositionsList from './positions-list';
import PositionsListHeader from './positions-list-header';

export default class PositionsSection extends IconTitleSection {
	#container!: Container;
	#createPositionRenderer!: CreatePositionRenderer;
	#positionsListHeader!: PositionsListHeader;
	#positionsList!: PositionsList;
	public constructor() {
		super();
		this.width = 'fill';
		this.height = 'fill';
		this.icon = 'list';
		this.text = 'Positioner';
	}

	public get container(): Container {
		if (!this.#container) {
			this.#container = new Container();
			this.#container.width = 'fill';
			this.#container.height = 'fill';
			this.#container.autoLayout = 'vertical';
			this.#container.gapVertical = 8;
			this.#container.addComponents([this.positionsListHeader, this.positionsList, this.createPositionRenderer]);
		}
		return this.#container;
	}

	public get createPositionRenderer(): CreatePositionRenderer {
		if (!this.#createPositionRenderer) {
			this.#createPositionRenderer = new CreatePositionRenderer();
		}
		return this.#createPositionRenderer;
	}

	public get positionsListHeader(): PositionsListHeader {
		if (!this.#positionsListHeader) {
			this.#positionsListHeader = new PositionsListHeader();
		}
		return this.#positionsListHeader;
	}

	public get positionsList(): PositionsList {
		if (!this.#positionsList) {
			this.#positionsList = new PositionsList();
		}
		return this.#positionsList;
	}

	protected override initialize(): void {
		super.initialize();
		this.body.addComponents([this.container]);
	}
}
customElements.define('ac-positions-section', PositionsSection);
